var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.mobileGallery)?_c('div',{key:"app-gallery"},[_c('MobileGallery')],1):_c('div',[_c('Slider'),_c('About'),_c('Galleries'),_c('Contact'),_c('Footer'),_c('Navbar')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }